'use client';

import React, { useState } from 'react';
import { useGetEngageStrategyDetailsQuery } from 'src/api/redux/strategy/engageStrategyApi';
import {
  StrategyProfileHeader,
  StrategyProfileMap,
  StrategyProfileList,
  EngageStrategyMetricsHeader,
} from '../../components';
import StrategyProfileLayout from '../StrategyProfileLayout';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { STRATEGY_COLORS } from '../..';

type View = 'map' | 'list';

interface PatientJourneyViewProps {
  engageStrategyId: string;
}

const PatientJourneyView: React.FC<PatientJourneyViewProps> = ({
  engageStrategyId,
}) => {
  const { useNewPatientJourney } = useFlags();

  const [view, setView] = useState<View>('map');

  const { data: engageStrategyDetails } = useGetEngageStrategyDetailsQuery(
    engageStrategyId,
    { skip: !engageStrategyId }
  );

  return (
    <StrategyProfileLayout>
      <StrategyProfileHeader
        view={view}
        setView={setView}
        description={engageStrategyDetails?.description || ''}
        title={engageStrategyDetails?.label || ''}
        isEngageStrategy={false}
        isPatientJourney={true}
      >
        {useNewPatientJourney && (
          <EngageStrategyMetricsHeader
            engageStrategyId={engageStrategyId}
            color={STRATEGY_COLORS['PATIENT_JOURNEY']}
          />
        )}
      </StrategyProfileHeader>

      <div
        className="flex flex-col w-full h-full gap-2"
        data-testid="patient-journey-content"
      >
        {view === 'map' ? (
          <StrategyProfileMap engageStrategyId={engageStrategyId} />
        ) : (
          <StrategyProfileList engageStrategyId={engageStrategyId} />
        )}
        <p
          className="text-tertiary text-sm font-normal leading-5"
          data-testid="patient-journey-disclaimer"
          role="note"
          aria-label="Data disclaimer"
        >
          <sup>*</sup>Patient-level data is not available for all Medicare FFS
          enrolled patients. Please consider this analysis directional.
        </p>
      </div>
    </StrategyProfileLayout>
  );
};

export default PatientJourneyView;
